// Persistent client-side error log, backed by localStorage so entries survive reloads.
const ERROR_LOG_KEY = "humankind:error_log";
const MAX_ENTRIES = 100;

export const logError = (message, stack, source) => {
  try {
    const existing = JSON.parse(localStorage.getItem(ERROR_LOG_KEY) || "[]");
    existing.push({ message: String(message || ""), stack: String(stack || ""), source: String(source || ""), time: Date.now() });
    while (existing.length > MAX_ENTRIES) existing.shift();
    localStorage.setItem(ERROR_LOG_KEY, JSON.stringify(existing));
  } catch {
    // localStorage unavailable or full - error logging is best-effort, never throw from here
  }
};

export const getErrorLog = () => {
  try {
    return JSON.parse(localStorage.getItem(ERROR_LOG_KEY) || "[]");
  } catch {
    return [];
  }
};

export const clearErrorLog = () => {
  try { localStorage.removeItem(ERROR_LOG_KEY); } catch { /* best-effort */ }
};

// Call once at app startup to catch errors outside the React render tree
// (async code, event handlers, promise rejections).
export const installGlobalErrorLogging = () => {
  window.addEventListener("error", (e) => {
    logError(e.message, e.error?.stack, "window.onerror");
  });
  window.addEventListener("unhandledrejection", (e) => {
    logError(e.reason?.message || String(e.reason), e.reason?.stack, "unhandledrejection");
  });
};
